import axios from "axios";
import { ErroMsg } from "../../frontend/contents/VariaveisGlobais";

const URL = window._env_?.REACT_APP_URL || process.env.REACT_APP_URL
const Port = window._env_?.REACT_APP_PORT || process.env.REACT_APP_PORT

const api = axios.create({
    baseURL: `${URL}:${Port}/api`,
    withCredentials: true, // 🔒 envia cookie HttpOnly automaticamente
    headers: {
        "Content-Type": "application/json",
        "Accept": "*/*",
        "Cache-Control": "no-cache, no-store, must-revalidate"
    }
});

async function ConsumoAPI_PUT(rota, body) {
    try {
        const response = await api.put(`/${rota}`, body);
        return response.data;
    } catch (err) {
        let mensagem = err.response?.data?.error || err.message;
        ErroMsg(mensagem);
        return { data: [], error: mensagem };
    }
}

async function ConsumoAPI_POST(rota, body) {
    try {
        const response = await api.post(`/${rota}`, body);
        return response.data;
    } catch (err) {
        let mensagem = err.response?.data?.error || err.message;
        ErroMsg(mensagem);
        return { data: [], error: mensagem };
    }
}

async function ConsumoAPI_DELETE(rota, body) {
    try {
        const response = await api.delete(`/${rota}`, { data: body });
        return response.data;
    } catch (err) {
        let mensagem = err.response?.data?.error || err.message;
        ErroMsg(mensagem);
        return { data: [], error: mensagem };
    }
}

async function ConsumoAPI_FileUpload(fileUpload) {
    const formData = new FormData();
    fileUpload.forEach(file => formData.append('files', file));

    try {
        const response = await axios.post(
            `${URL}:${Port}/api/salvarArquivo`,
            formData,
            {
            withCredentials: true, // 👈 necessário aqui também
            headers: {
                "Content-Type": "multipart/form-data"
            }
            }
        );
        return response.data;
    } catch (err) {
        ErroMsg('Erro ao fazer upload! ' + err.message);
        return { data: [], error: err.message };
    }
}

async function ConsumoAPI_FileDelete(fileName) {
    try {
        const response = await axios.delete(
            `${URL}:${Port}/api/salvarArquivo/${fileName}`,
            {
            withCredentials: true,
            }
        );
        return response.data;
    } catch (err) {
        ErroMsg('Erro ao excluir o arquivo! ' + err.message);
        return { data: [], error: '01', description: 'Erro ao excluir o arquivo.' };
    }
}

export {
  ConsumoAPI_POST,
  ConsumoAPI_PUT,
  ConsumoAPI_DELETE,
  ConsumoAPI_FileUpload,
  ConsumoAPI_FileDelete
};
